import { render, staticRenderFns } from "./LoggedInAsBanner.vue?vue&type=template&id=fb5c03c6&scoped=true"
import script from "./LoggedInAsBanner.vue?vue&type=script&lang=js"
export * from "./LoggedInAsBanner.vue?vue&type=script&lang=js"
import style0 from "./LoggedInAsBanner.vue?vue&type=style&index=0&id=fb5c03c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5c03c6",
  null
  
)

export default component.exports